import React, { ComponentType } from "react";
import { wrappedDisplayName } from "./ReactUtil";

interface ConnectableStore {
	getState: () => object;
	listen: (unsubscribe: () => void) => () => void;
}

export function connectStore<P>(Component: ComponentType<P>, store: ConnectableStore, actions?: any) {
	class Wrapper extends React.Component {
		unsubscribe: () => void = () => {};

		constructor(props) {
			super(props);

			if (!store) {
				throw new Error(`Component '${Component.name}' is using RefluxConnect with no store defined!`);
			}

			this.unsubscribe = store.listen(() => this.forceUpdate());
		}

		componentWillUnmount() {
			this.unsubscribe();
		}

		getProps() {
			// NOTE: this is a performance critical point in the code. Do not use e.g.
			// _.merge, as it "recursively merges own and inherited enumerable string keyed properties", which
			// takes a while for large objects.
			return { ...store.getState(), ...actions, ...this.props };
		}

		render() {
			return <Component {...this.getProps()} />;
		}
	}

	// @ts-expect-error
	Wrapper.displayName = wrappedDisplayName("connectStore", Component);
	return Wrapper as React.ComponentType<any>;
}

export function connectActions<P>(Component: React.ComponentType<P>, actions?: any) {
	function Wrapper(props) {
		const combinedProps = { ...actions, ...props };
		return <Component {...combinedProps} />;
	}

	Wrapper.displayName = wrappedDisplayName("connectActions", Component);
	return Wrapper;
}
